const URL_FCM_INSTANCES = "https://com-surpnorm-senseev.appspot.com/v1/fcmInstances";

class FcmInstancesApi {

  static requestHeaders(deviceId, authToken) {
    return {'Authorization': `Bearer deviceId="${deviceId}",authenticationToken="${authToken}"`}
  }

  static subscribe(deviceId, authToken, firebaseInstanceIdToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_FCM_INSTANCES}/${firebaseInstanceIdToken}`, {
      method: 'PUT',
      headers: headers
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
      return error;
    });
  }

  static unsubscribe(deviceId, authToken, firebaseInstanceIdToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_FCM_INSTANCES}/${firebaseInstanceIdToken}`, {
      method: 'DELETE',
      headers: headers
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
      return error;
    });
  }
}

export default FcmInstancesApi;


// WEBPACK FOOTER //
// ./src/api/fcmInstancesApi.js